import { render, staticRenderFns } from "./auto_fix_help_text.vue?vue&type=template&id=15c50982&"
import script from "./auto_fix_help_text.vue?vue&type=script&lang=js&"
export * from "./auto_fix_help_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports